import { twMerge } from '@shared/themes';
import { Fragment, type ComponentProps, type ReactNode } from 'react';

type ItemsGridProps<T> = ComponentProps<'div'> & {
  items: T[];
  renderItem: (item: T, index: number) => ReactNode;
};

/**
 * A reusable grid component that displays items in a responsive grid layout
 * (2 columns on desktop, 1 on mobile). Each item is rendered using a custom render function.
 *
 * @param items - Array of items to display
 * @param renderItem - Function to render each item
 * @param className - Additional CSS classes (e.g., 'gap-4' for spacing)
 */
function ItemsGrid<T>({ items, renderItem, className, ...props }: ItemsGridProps<T>) {
  return (
    <div className={twMerge('grid grid-cols-1 md:grid-cols-2 gap-2', className)} {...props}>
      {items.map((item, index) => (
        <Fragment key={index}>{renderItem(item, index)}</Fragment>
      ))}
    </div>
  );
}

export { ItemsGrid, type ItemsGridProps };
